module.exports = __webpack_public_path__ + "static/media/Base Angel.2fdadce0.png";